import { createEventBridge as _createEventBridge,createRealTimeEventBridge as _createRealTimeEventBridge } from 'src/services/events/event';
import { mkEventsBridgeData } from 'src/services/objects/events';

export const useEventsBridgeHook = (source: string, action: string, updDocs?: any) => {
  const createEventBridge = (data: any, postActionFn: any) => {
    return _createEventBridge(mkEventsBridgeData(source, action, data, updDocs)).then(
      (res) => {
        postActionFn();
      }
    ).catch(e => {
      postActionFn();
    });
  };
  const createRealTimeEventBridge = (data: any, postActionFn: any) => {
    return _createRealTimeEventBridge(mkEventsBridgeData(source, action, data, updDocs)).then(
      (res) => {
        postActionFn();
      }
    ).catch(e => {
      postActionFn();
    });
  };

  return { createEventBridge,createRealTimeEventBridge };
};
